module.exports = __webpack_public_path__ + "static/media/3.eb765d77.png";